// Data sevice
import axios from 'axios';
import authHeader from './auth-header';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class CitiesService {
  index() {
    return axios.get(API_URL + 'cities', { headers: authHeader() });
  }
  show(id) {
    return axios.get(API_URL + 'cities/' + id, { headers: authHeader() });
  }
  store(resource) {
    return axios.post(API_URL + 'cities', resource, { headers: authHeader() });
  }
  update(resource) {
    return axios.put(API_URL + 'cities/' + resource.id, resource, { headers: authHeader() });
  }
  delete(resource) {
    return axios.delete(API_URL + 'cities/' + resource.id, { headers: authHeader() });
  }

  // public
  getCountryCities(id) {
    return axios.get(API_URL + 'get-cities/' + id, { headers: authHeader() });
  }
}

export default new CitiesService();
